import axios from "axios";
import { ADMIN_PORTAL_AUTH_TOKEN, ADMIN_PORTAL_API_BASE_URL } from "../utils/config";

export const uploadCta = async (selectedState) => {
    let payload = {
        source: selectedState["source"],
        lob_value: selectedState["lob name"] || " ",
        cta_name_value: selectedState["cta name"],
        description: selectedState["description"],
        deeplink: selectedState["deeplink"],
    }
    let config = {
        method: "post",
        url: `${ADMIN_PORTAL_API_BASE_URL}/upload_cta`,
        data: payload,
        headers: {
            Authorization: "Bearer " + ADMIN_PORTAL_AUTH_TOKEN
        }
    };
    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}